export function showFormMessage(scope: HTMLElement, key: string | null) {
  scope.querySelectorAll<HTMLElement>('[data-form-message]').forEach(el => {
    el.classList.toggle('hidden', el.dataset.formMessage !== key);
  });
}
